import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/views/home/index'
import Middle from '@/views/middle/index'
import Search from '@/views/search/index'
import MeetingListOld from '@/views/meeting/list/index'
import MeetingNewsDetail from '@/views/meeting/news_detail/index'
import CourseList from '@/views/course/list/index'
import CourseDetail from '@/views/course/detail/index'
import CourseColumn from '@/views/course/column/index'
import VideoDetail from '@/views/video/detail/index'
import VideoColumn from '@/views/video/column/index'
import ArticleList from '@/views/article/list/index'
import ArticleColumn from '@/views/article/column/index'
import ArticleDetail from '@/views/article/detail/index'
import ShortVideoList from '@/views/short-video/list/index'
import ShortVideoDetail from '@/views/short-video/detail/index'
import LiveList from '@/views/live/list/index'
import LiveStudy from '@/views/live/study_list/index'
import LiveColumn from '@/views/live/column/index'
import LiveColumnList from '@/views/live/column_list/index'
import LiveColumnDetail from '@/views/live/column_detail/index'
import LiveDetail from '@/views/live/detail/index'
import LiveDetailHome from '@/views/live/detail_home/index'
import My from '@/views/my/index'
import MyAmount from '@/views/my/amount/index'
import AmountRule from '@/views/my/amount-rule/index'
import MyHistory from '@/views/my/history/index'
import MyFavorite from '@/views/my/favorite/index'
import MyFocus from '@/views/my/focus/index'
import MyListOrder from '@/views/my/list_order/index'
import MyService from '@/views/my/service/index'
import MySetting from '@/views/my/setting/index'
import MyUpdateTel from '@/views/my/update-tel/index'
import MySendVerify from '@/views/my/my-send-verify/index'
import Login from '@/views/login/login/index'
import YS from '@/views/login/ys/index'
import SendVerify from '@/views/login/send-verify/index'
import AddInfo from '@/views/login/add-info/index-new'
import ChooseHospital from '@/views/login/choose-hospital/index-new'
import AddHospital from '@/views/login/choose-hospital/add-hospital'
import ChooseOffice from '@/views/login/choose-office/index-new'
import CaseList from '@/views/case/list/index'
import ClinicList from '@/views/clinic/list/index'
import ActivityList from '@/views/activity/list/index'
import ActivityDetail from '@/views/activity/detail/index'
import DownloadList from '@/views/download/list/index'
import DownloadDetail from '@/views/download/detail/index'
import StudyGroupRecruitment from '@/views/topic/study-group-recruitment/index'
import Honor from '@/views/topic/honor/index/index'
import HonorDetail from '@/views/topic/honor/detail/detail'

import TopicList from '@/views/topic/topic-list/index'
import TopicDetail from '@/views/topic/topic-detail/index'
import TopicColumn from '@/views/topic/topic-column/index'
import TopicDesc from '@/views/topic/topic-desc/index'
import TopicNewsList from '@/views/topic/topic-news-list/index'

import AcademicAssociation from '@/views/academic-association/index'
// v4
import HomeNew from '@/views/home/index_new'
import clinicCourse from '@/views/clinic-course/index'
import clinicList from '@/views/clinic-course/list-new'
import SearchNew from '@/views/search/index-new'
import channelMore from '@/views/home/list.vue'
import ImageText from '@/views/image-text/index.vue'
// 学术会
import MeetingList from '@/views/meeting/list/index-new'
// 医学专栏
import MedicalColumn from '@/views/medical-column/index.vue'
import MedicalColumnList from '@/views/medical-column/list/index.vue'
import MedicalColumnDetail from '@/views/medical-column/detail/index.vue'

// 直播我的预约
import LiveAppointmentList from '@/views/live/appointment-list/index.vue'

// 病例实战 专栏
import CaseColumn from '@/views/case/column/index.vue'

Vue.use(Router)

export default new Router({
    routes: [

      {
        path: '/',
        name: 'home-new',
        meta: {
          index: 0,
          title: '博医荟-推荐'
        },
        component: HomeNew
      },
      {
          path: '/old-home',
          name: 'home',
          meta: {
              index: 0,
              title: '博医荟'
          },
          component: HomeNew
      },
        // 没有对应文件
        {
            path: '/middle',
            name: 'middle',
            meta: {
                index: 0,
                title: "博医荟"
            },
            component: Middle
        },
        {
            path: '/search',
            name: 'search',
            meta: {
                index: 1,
                title: '搜索'
            },
            component: Search
        },
        {
            path: '/meeting-list-old',
            name: 'meeting-list-old',
            meta: {
                index: 1,
                title: '学术会'
            },
            component: MeetingListOld
        },
        {
            path: '/meeting-list',
            name: 'meeting-list',
            meta: {
                index: 1,
                title: '学术会'
            },
            component: MeetingList
        },
        {
            path: '/meeting-news-detail/:id',
            name: 'meeting-news-detail',
            meta: {
                index: 1,
                title: '新闻详情'
            },
            component: MeetingNewsDetail
        },
        {
            path: '/course-list',
            name: 'course-list',
            meta: {
                index: 1,
                title: '精品课程'
            },
            component: CourseList
        },
        {
            path: '/course-column/:id',
            name: 'course-column',
            meta: {
                index: 2,
                title: '课程专栏'
            },
            component: CourseColumn
        },
        {
            path: '/course-detail/:id',
            name: 'course-detail',
            meta: {
                index: 3,
                title: '课程详情'
            },
            component: CourseDetail
        },
        {
            path: '/video-column/:id',
            name: 'video-column',
            meta: {
                index: 2,
                title: '视频专栏'
            },
            component: VideoColumn
        },
        {
            path: '/video-detail/:id',
            name: 'video-detail',
            meta: {
                index: 3,
                title: '视频详情'
            },
            component: VideoDetail
        },
        {
            path: '/article-list',
            name: 'article-list',
            meta: {
                index: 1,
                title: '资讯'
            },
            component: ArticleList
        },
        {
            path: '/article-column/:id',
            name: 'article-column',
            meta: {
                index: 2,
                title: '资讯专栏'
            },
            component: ArticleColumn
        },
        {
            path: '/article-detail/:id',
            name: 'article-detail',
            meta: {
                index: 2,
                title: '资讯详情'
            },
            component: ArticleDetail
        },
        {
            path: '/short-video-list',
            name: 'short-video-list',
            meta: {
                index: 1,
                title: '短视频列表'
            },
            component: ShortVideoList
        },
        {
            path: '/short-video-detail/:id',
            name: 'short-video-detail',
            meta: {
                index: 2,
                title: '短视频详情'
            },
            component: ShortVideoDetail
        },

        {
            path: '/live-list',
            name: 'live-list',
            meta: {
                index: 1,
                title: '直播',
            },
            component: LiveList
        },
        {
            path: '/live-study',
            name: 'live-study',
            meta: {
                index: 1,
                title: '高博内训学术专区'
            },
            component: LiveStudy
        },
        {
            path: '/live-column/:id',
            name: 'live-column',
            meta: {
                index: 2,
                title: '专栏详情'
            },
            component: LiveColumn
        },
        {
            path: '/live-column-list',
            name: 'live-column-list',
            meta: {
                index: 2,
                title: '专题直播'
            },
            component: LiveColumnList
        },
        {
            path: '/live-column-detail',
            name: 'live-column-detail',
            meta: {
                index: 2,
                title: '直播专题详情'
            },
            component: LiveColumnDetail
        },
        {
            path: '/live-detail/:id',
            name: 'live-detail',
            meta: {
                index: 2,
                title: '直播详情'
            },
            component: LiveDetail
        },
        {
            path: '/live-detail-home/:id',
            name: 'live-detail-home',
            meta: {
                index: 2,
                title: '直播间'
            },
            component: LiveDetailHome
        },
        {
            path: '/my',
            name: 'my',
            meta: {
                index: 0,
                title: '我的'
            },
            component: My
        },
        {
            path: '/my-history',
            name: 'my-history',
            meta: {
                index: 1,
                title: '我的足迹'
            },
            component: MyHistory
        },
        {
            path: '/my-focus',
            name: 'my-focus',
            meta: {
                index: 1,
                title: '我的关注'
            },
            component: MyFocus
        },
        {
            path: '/ys',
            name: 'ys',
            meta: {
                index: 1,
                title: '隐私协议'
            },
            component: YS
        },
        {
            path: '/my-amount',
            name: 'my-amount',
            meta: {
                index: 1,
                title: '我的账户'
            },
            component: MyAmount
        },
        {
            path: '/amount-rule',
            name: 'amount-rule',
            meta: {
                index: 2,
                title: '积分规则'
            },
            component: AmountRule
        },
        {
            path: '/my-favorite',
            name: 'my-favorite',
            meta: {
                index: 1,
                title: '我的收藏'
            },
            component: MyFavorite
        },
        {
            path: '/my-list-order',
            name: 'my-list-order',
            meta: {
                index: 1,
                title: '我的预约'
            },
            component: MyListOrder
        },
        {
            path: '/my-service',
            name: 'my-service',
            meta: {
                index: 1,
                title: '联系客服'
            },
            component: MyService
        },
        {
            path: '/my-setting',
            name: 'my-setting',
            meta: {
                index: 1,
                title: '设置'
            },
            component: MySetting
        },
        {
            path: '/my-update-tel',
            name: 'my-update-tel',
            meta: {
                index: 2,
                title: '修改手机号'
            },
            component: MyUpdateTel
        },
        {
            path: '/my-send-verify',
            name: 'my=send-verify',
            meta: {
                index: 3,
                title: '更改手机号'
            },
            component: MySendVerify
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                index: 5,
                title: '登录'
            },
            component: Login
        },
        {
            path: '/send-verify',
            name: 'send-verify',
            meta: {
                index: 6,
                title: '发送验证码'
            },
            component: SendVerify
        },
        {
            path: '/add-info',
            name: 'add-info',
            meta: {
                index: 7,
                title: '补充信息'
            },
            component: AddInfo
        },
        {
            path: '/choose-hospital',
            name: 'choose-hospital',
            meta: {
                index: 8,
                title: '选择医院'
            },
            component: ChooseHospital
        },
        {
            path: '/add-hospital',
            name: 'add-hospital',
            meta: {
                index: 8,
                title: '添加医院'
            },
            component: AddHospital
        },
        {
            path: '/choose-office',
            name: 'choose-office',
            meta: {
                index: 8,
                title: '选择科室'
            },
            component: ChooseOffice
        },
        {
            path: '/case-list',
            name: 'case-list',
            meta: {
                index: 1,
                title: '病例实战'
            },
            component: CaseList
        },
        {
            path: '/case-column/:id',
            name: 'case-column',
            meta: {
                index: 1,
                title: '病例专栏'
            },
            component: CaseColumn
        },
        {
            path: '/clinic-list',
            name: 'clinic-list',
            meta: {
                index: 1,
                title: '培训与科研'
            },
            component: ClinicList
        },
        {
            path: '/activity-list',
            name: 'activity-list',
            meta: {
                index: 1,
                title: '荟议日历'
            },
            component: ActivityList
        },
        {
            path: '/activity-detail/:id',
            name: 'activity-detail',
            meta: {
                index: 1,
                title: '荟议详情'
            },
            component: ActivityDetail
        },
        {
            path: '/download-list',
            name: 'download-list',
            meta: {
                index: 1,
                title: '资料文库'
            },
            component: DownloadList
        },
        {
            path: '/download-detail/:id',
            name: 'download-detail',
            meta: {
                index: 1,
                title: '资料文库详情'
            },
            component: DownloadDetail
        },
        {
            path: '/topic-list',
            name: 'topic-list',
            meta: {
                index: 1,
                title: '学/协会'
            },
            component: TopicList
        },
        {
            path: '/topic-detail/:id',
            name: 'topic-detail',
            meta: {
                index: 1,
                title: ''
            },
            component: TopicDetail
        },
        {
            path: '/topic-column/:topic_id/:topic_subject_id',
            name: 'topic-column',
            meta: {
                index: 1,
                title: '专题详情'
            },
            component: TopicColumn
        },
        {
            path: '/topic-desc/:id',
            name: 'topic-desc',
            meta: {
                index: 1,
                title: '专题简介'
            },
            component: TopicDesc
        },
        {
            path: '/topic-news-list/:id',
            name: 'topic-news-list',
            meta: {
                index: 1,
                title: '专题新闻列表'
            },
            component: TopicNewsList
        },
        {
            path: '/study-group-recruitment/:topic_id/:topic_subject_id',
            name: 'study-group-recruitment',
            meta: {
                index: 1,
                title: '学组纳新'
            },
            component: StudyGroupRecruitment
        },
        {
            path: '/topic-honor/:topic_id',
            name: 'topic-honor',
            meta: {
                index: 1,
                title: '荣誉奖项'
            },
            component: Honor
        },
        {
            path: '/topic-honor-detail/:topic_id/:id',
            name: 'topic-honor-detail',
            meta: {
                index: 1,
                title: '荣誉奖项'
            },
            component: HonorDetail
        },
        {
            path: '/academic-association',
            name: 'academic-association',
            meta: {
                index: 1,
                title: '博医荟'
            },
            component: AcademicAssociation
        },
        {
            path: '/channel-more/:id/:origin_type',
            name: 'channel-more',
            meta: {
                index: 0,
                title: '博医荟'
            },
            component: channelMore
        },
        {
            path: '/clinic-course',
            name: 'clinic-course',
            meta: {
                index: 0,
                title: '临床好课-推荐'
            },
            component: clinicCourse
        },
        {
            path: '/clinic-list-new',
            name: 'clinic-list-new',
            meta: {
                index: 0,
                title: '临床好课-课程上新'
            },
            component: clinicList
        },
        {
            path: '/search-new',
            name: 'search-new',
            meta: {
                index: 1,
                title: '搜索'
            },
            component: SearchNew
        },
        {
            path: '/image-text/:id',
            name: 'image-text',
            meta: {
                index: 1,
                title: '图文详情'
            },
            component: ImageText
        },
        {
            path: '/medical-column',
            name: 'medical-column',
            meta: {
                index: 1,
                title: '医学专栏'
            },
            component: MedicalColumn
        },
        {
            path: '/live-appointment-list',
            name: 'live-appointment-list',
            meta: {
                index: 1,
                title: '直播我的预约'
            },
            component: LiveAppointmentList
        },
        {
            path: '/medical-column-list/:id',
            name: 'medical-column-list',
            meta: {
                index: 1,
                title: '医学专栏'
            },
            component: MedicalColumnList
        },
        {
            path: '/medical-column-detail/:id',
            name: 'medical-column-detail',
            meta: {
                index: 1,
                title: '医学专栏-详情'
            },
            component: MedicalColumnDetail
        }
    ]
})

const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js